import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { CompanyAccount } from "model";

export default function CaptureTemplateDetailsMainCompanySelected(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update([ "template", "secCode" ], "PPD Credit - Consumer Credit")
    .update([ "template", "name" ], "New Payroll")
    .update([ "template", "companyDiscretionaryData" ], "Bi-Weekly")
    .update([ "template", "companyEntryDescription" ], "Payroll")
    .update([ "template", "companyAccount" ], CompanyAccount.initByID(0))
    .submit();
    
    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showSecCode", "isActive" ], true)
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .submit();
    
  return (
    <TemplateDetailsPage data={data} ui={ui} />
  )
}
